// 8" single cap. Config comes from snippets/nr-qty-cap.liquid (window.NRQtyCap).
(() => {
  const cfg = window.NRQtyCap;
  if (!cfg || !cfg.max) return;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const isSingle = (sku) => typeof sku === 'string' && sku.indexOf(cfg.prefix) === 0;
  const singlesIn = (cart) => cart.items.reduce((n, item) => n + (isSingle(item.sku) ? item.quantity : 0), 0);
  const getCart = () => fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json());

  // For custom add-to-cart code (e.g. assets/nr-color-launch.js) that doesn't go through a form.
  cfg.allows = (sku, quantity) =>
    isSingle(sku)
      ? getCart()
          .then((cart) => singlesIn(cart) + quantity <= cfg.max)
          .catch(() => true)
      : Promise.resolve(true);

  function showProductMessage(form, html) {
    const wrapper = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
    const message = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !message) return;
    message.innerHTML = html;
    wrapper.toggleAttribute('hidden', false);
  }

  // Product page: check the cart before letting an 8" single through. Runs in the capture phase so it
  // fires before ProductForm's own submit handler, then re-submits the form if the add is allowed.
  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
      if (form.dataset.nrCapChecked === 'true') {
        delete form.dataset.nrCapChecked;
        return;
      }

      const data = new FormData(form);
      const message = cfg.singles[String(data.get('id'))];
      if (!message) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const quantity = parseInt(data.get('quantity'), 10) || 1;

      const resubmit = () => {
        form.dataset.nrCapChecked = 'true';
        if (form.requestSubmit) form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      };

      getCart()
        .then((cart) => (singlesIn(cart) + quantity <= cfg.max ? resubmit() : showProductMessage(form, message)))
        .catch(resubmit);
    },
    true
  );

  // Any page: an over-cap cart (from before the cap, or a /cart/add link) gets trimmed back down,
  // newest lines first. The cart page reloads so its totals and the cap message are right.
  if (cfg.inCart > cfg.max) {
    getCart()
      .then((cart) => {
        let over = singlesIn(cart) - cfg.max;
        if (over <= 0) return;
        const updates = {};
        for (const item of cart.items) {
          if (over <= 0) break;
          if (!isSingle(item.sku)) continue;
          const cut = Math.min(over, item.quantity);
          updates[item.key] = item.quantity - cut;
          over -= cut;
        }
        return fetch(`${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates }),
        }).then((response) => {
          if (response.ok && document.querySelector('cart-items')) window.location.reload();
        });
      })
      .catch(() => {});
  }
})();
